function onVisible(element, callback) {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        if (entry.boundingClientRect.top < window.innerHeight) {
          callback(element)
        }
        observer.disconnect()
      }
    })
  }, observerOptions)

  observer.observe(element)

  if (!callback) return new Promise((r) => (callback = r))
}

export default onVisible
